<template>
    <v-app>
        <AppHeader />
        <v-main>
            <RouterView />
        </v-main>
        <AppFooter />
        <SnackBar />
        <LoadingOverlay />
    </v-app>
</template>

<script setup>
import { RouterView } from 'vue-router'
import { useTheme } from 'vuetify'
import INJECTION_KEYS from '@injectionKeys'
import { inject, onMounted } from 'vue'

/** @type {GlobalState} */
const globalState = inject(INJECTION_KEYS.GLOBALSTATE)

const theme = useTheme()

onMounted(() => {
    theme.change(globalState.systemConfig.theme || 'highQTheme')
})
</script>

